import { render } from "./CampoOrario.vue?vue&type=template&id=357e4658"
import script from "./CampoOrario.vue?vue&type=script&lang=js"
export * from "./CampoOrario.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__